export default "__VITE_ASSET__Cc_o685Q__"